import axios, { isCancel } from 'axios'
import store from '../store/'
import $Cookies from 'js-cookie'
import { Toast } from 'vant'

import { filterResponseStatus } from './error-response'

function createError(e) {
  if (!e) return null
  let err
  if (typeof e === 'string') {
    err = createError(new Error(e))
  } else {
    err = {
      name: e.name || '',
      message: e.message || e.msg || '',
      stack: e.stack || '',
      isCancel: isCancel(e)
    }
  }
  return err
}

function getformData(obj = {}) {
  let formData = new FormData()
  for(let i in obj) formData.append(i, obj[i])
  return formData
}

// create an axios instance
export function createService(baseURL) {
  let instance = axios.create({
    baseURL: baseURL || '', // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
  })

  // request interceptor
  instance.interceptors.request.use(
    config => {
      // 如果不存UUID就退出登录状态
      if (!$Cookies.get('UUID')) store.commit('LOGIN_OUT')
      // do something before request is sent
      config.headers = { 'Content-Type': 'application/json;charset=UTF-8' }
      config.url = '/api' + config.url
      let str = null
      if (config.method === 'get' || config.method === 'delete') str = 'params'
      if (config.method === 'post' || config.method === 'put') str = 'data'
      const lang = $Cookies.get('lang')
      if (!config[str]['lang']) config[str]['lang'] = lang || 'en_US'
      config[str]['appVersion'] = '1.0';
      config[str]['appType'] = 'h5';
      config[str]['frontType'] = store.state.frontType
      if (config.method === 'post') config.data = getformData(config.data)
      // config[str] = getformData(config[str])
      return config
    },
    error => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
    }
  )

  // response interceptor
  instance.interceptors.response.use(response => {
      const res = response.data
      if (res.code !== 200) {
        let msg = res.message || res.msg
        if (res.code === 99999) {
          let timer = setTimeout(function() {
            location.hash = `/404?err=${msg}`
            clearTimeout(timer)
          }, 1500)
        }
        loginOut(res.code, msg)
        return [res.data, createError(msg), response]
      } else {
        return Promise.resolve([res.data, null, response])
      }
    },
    error => {
      if (error && error.response) {
        // error.message = filterResponseStatus(error.response.status)
        loginOut(error.response.status)
        const { message, msg } = error.response.data
        Toast({ message: message || msg, icon: 'warning', duration: 3000 })
      }
      return Promise.resolve([null, createError(error), error.response])
    }
  )
  return instance
}

function loginOut(code, msg) { // 退出
  let showmsg = false
  if (code === 403 || code === 701 || code === 706 || code === 707) { // 需要退出登录
    store.commit('LOGIN_OUT')
    $Cookies.remove('UUID')
    showmsg = true
  }
  if (code >= 500 && code !== 505 && code !== 909) showmsg = true
  if (showmsg && msg) Toast({ message: msg || 'Error', icon: 'warning', duration: 3000 })
}

export const service = createService()



// WEBPACK FOOTER //
// ./src/common/request/request.js